const features = [
  {
    id: 1,
    number: "01",
    title: "خبرة متخصصة",
    description:
      "خبرة متراكمة في مجال إعادة التدوير وإدارة المواد القابلة لإعادة الاستخدام.",
  },
  {
    id: 2,
    number: "02",
    title: "حلول متكاملة",
    description:
      "نقدم حلولًا متكاملة تبدأ من جمع المواد وفرزها وحتى تجهيزها لإعادة التدوير.",
  },
  {
    id: 3,
    number: "03",
    title: "شراكات موثوقة",
    description:
      "نبني علاقات طويلة الأمد مع العملاء والشركاء لتحقيق قيمة مستدامة.",
  },
  {
    id: 4,
    number: "04",
    title: "الاستدامة",
    description:
      "نسعى إلى دعم الممارسات التي تساهم في تقليل الهدر وتعزيز الاستدامة البيئية.",
  },
];

export default function WhyUsSection() {
  return (
    <section className="bg-gray-50 py-20" dir="rtl">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        {/* العنوان */}
        <div className="mx-auto mb-14 max-w-2xl text-center">
          <span className="mb-3 block text-sm font-semibold text-green-600">
            لماذا نحن؟
          </span>

          <h2 className="text-3xl font-bold leading-tight text-gray-900 md:text-4xl">
            لماذا تختار خبراء التدوير؟
          </h2>

          <p className="mt-4 leading-8 text-gray-600">
            نعمل على تقديم حلول عملية وموثوقة تساعد عملاءنا على إدارة المواد
            القابلة لإعادة التدوير بكفاءة واستدامة.
          </p>
        </div>

        {/* المحتوى */}
        <div className="grid items-center gap-12 lg:grid-cols-2">
          {/* الجانب البصري */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-3xl">
              <img
                src="/images/why-us/recycling.jpg"
                alt="إعادة التدوير"
                className="h-[460px] w-full object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            </div>

            {/* العنصر الأخضر */}
            <div className="absolute -bottom-6 -left-6 hidden rounded-2xl bg-green-600 p-7 text-white shadow-xl sm:block">
              <div className="text-4xl font-bold">20+</div>

              <div className="mt-1 text-sm text-white/90">عامًا من الخبرة</div>
            </div>
          </div>

          {/* المميزات */}
          <div className="space-y-7">
            {features.map((feature) => (
              <div
                key={feature.id}
                className="group flex gap-5 border-b border-gray-200 pb-7 last:border-b-0"
              >
                {/* الرقم */}
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-green-100 text-sm font-bold text-green-600 transition duration-300 group-hover:bg-green-600 group-hover:text-white">
                  {feature.number}
                </div>

                {/* النص */}
                <div>
                  <h3 className="mb-2 text-xl font-bold text-gray-900">
                    {feature.title}
                  </h3>

                  <p className="leading-7 text-gray-600">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
